import { useGetSetupUrl, useTenants } from "@sg-protect/shell";
import { type PropsWithChildren } from "react";
import { Navigate } from "react-router";

export function WorkspaceTenantGate({ children }: PropsWithChildren) {
    const hasTenant = (useTenants().tenants?.migrateAssessmentTenants.length ?? 0) > 0;
    const consentRedirectUrl = useGetSetupUrl("migrateAssessment");

    if (!hasTenant) {
        return <Navigate to={consentRedirectUrl} replace />;
    }

    return children;
}
